import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

export interface IBuildCatalogUrlOptions {
  segments?: (string | undefined | null | false)[];
  query?: string;
}

export const buildCatalogUrl = ({
  segments = [],
  query,
}: IBuildCatalogUrlOptions): string => {
  const parts = segments.filter((s): s is string => Boolean(s));
  const path = parts.length ? `${parts.join('/')}/` : '';
  const qs = query ? `?${query}` : '';

  return `${ROOT_CATALOG_URL}${path}${qs}`.replace(/\/\?/, '?');
};
